module.exports = __webpack_public_path__ + "img/tctp_main.313ae0b9.png";